export default __webpack_public_path__ + "static/media/crop_white.1aecb831.svg";